import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useAuth } from 'react-oidc-context';
import { Icon } from '@iconify/react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import LoadingButton from '@mui/lab/LoadingButton';
import { alpha } from '@mui/material/styles';
import { useTranslations } from '../hooks/use-translations';

function LogIn() {
  const auth = useAuth();
  const { t } = useTranslations();
  const isBusy = auth.isLoading || Boolean(auth.activeNavigator);
  const hasError = Boolean(auth.error);

  useEffect(() => {
    if (auth.error) {
      console.error('Sign-in error', auth.error);
    }
  }, [auth.error]);

  const handleSignIn = () => {
    auth.signinRedirect();
  };

  return (
    <>
      <Helmet>
        <title>{t('login.pageTitle')}</title>
      </Helmet>

      <Box
        sx={{
          minHeight: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 3,
          background: (theme) =>
            `linear-gradient(90deg, ${theme.palette.common.white} 0%, ${alpha(theme.palette.primary.lighter, 0.7)} 100%)`,
        }}
      >
        <Stack spacing={3} alignItems="center">
          <Box
            component="img"
            src="/assets/bosca_logo.png"
            alt={t('account.cloudloqLogo')}
            sx={{ height: 48, width: 'auto', maxWidth: 260 }}
          />

          {hasError && (
            <Alert severity="error" sx={{ maxWidth: 360 }}>
              {t('login.errorDescription')}
            </Alert>
          )}

          <LoadingButton
            size="large"
            variant="contained"
            onClick={handleSignIn}
            loading={isBusy}
            startIcon={!isBusy ? <Icon icon="mdi:login" width={18} height={18} /> : undefined}
            sx={{
              minWidth: 160,
              boxShadow: (theme) => theme.customShadows.primary,
            }}
          >
            {hasError ? t('login.tryAgain') : t('login.signIn')}
          </LoadingButton>
        </Stack>
      </Box>
    </>
  );
}

export default LogIn;
